import React from 'react';

import { Link } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import { RouteList } from 'types';

import notFoundSvg from '../../../assets/404.svg';

export const Error404 = () => {
  return (
    <>
      <img alt="Seite nicht gefunden" style={{ maxHeight: 180 }} src={notFoundSvg} />
      <Stack spacing={2} alignItems="center">
        <Typography variant="h1">404</Typography>
        <Typography variant="h1">Seite nicht gefunden</Typography>
        <Typography sx={{ maxWidth: '350px' }} textAlign="center">
          Die Seite, die du suchst, wurde verschoben, entfernt, umbenannt oder existiert vielleicht gar nicht.
        </Typography>
      </Stack>
      <Button component={Link} to={RouteList.MyCampaigns} color="primary" variant="contained">
        Zu meinen kampagnen
      </Button>
    </>
  );
};
